import { Interactions } from "../core/providers/interactions.provider.tsx";

export function PatientTimelineWidget() {
  const { current } = Interactions.usePatient();
  if (!current) {
    return (
      <p className="px-1 text-xs text-sf-text-muted">
        Historique récent du patient sélectionné.
      </p>
    );
  }

  const events = [
    { date: "12/05/2026", label: "Contrôle mensuel", type: "rdv" },
    { date: "28/04/2026", label: "Activation arc sup.", type: "acte" },
    { date: "15/04/2026", label: "Message patient reçu", type: "msg" },
    { date: current.last, label: "Dernier RDV enregistré", type: "rdv" },
  ];

  return (
    <ol className="relative flex flex-col gap-0 border-l border-sf-border pl-4">
      {events.map((ev, i) => (
        <li key={i} className="relative pb-3 last:pb-0">
          <span className="absolute -left-[21px] top-1 flex h-2.5 w-2.5 rounded-full border-2 border-white bg-sf-primary ring-1 ring-sf-border" />
          <div className="text-[10.5px] text-sf-text-muted">{ev.date}</div>
          <div className="text-xs font-medium text-sf-text">{ev.label}</div>
        </li>
      ))}
    </ol>
  );
}
